var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNazLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 64,
    viewBox: "0 0 128 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6364 27.6069H114.103L101.492 38.8291L91.6364 27.6069ZM35.2001 43.5532L46.2991 31.1776V52.2773L35.2001 43.5532ZM65.6512 9.61065L74.7199 19.9458H56.3755L65.6512 9.61065ZM126.704 26.6488C127.901 25.5902 128.316 23.898 127.75 22.3964C127.199 20.8944 125.777 19.9029 124.189 19.9029H84.8716L68.5295 1.29165C67.8085 0.476799 66.7815 0.00454094 65.703 0H65.6796C64.6146 0 63.5875 0.457624 62.8671 1.25834L29.1607 38.8054L6.13858 20.7132C4.99382 19.8076 3.43874 19.6502 2.12945 20.294C0.824159 20.9423 0 22.2864 0 23.7552V63.9909H7.61289V31.6256L47.7734 63.1897C48.4565 63.7235 49.2761 64 50.1098 64C50.6802 64 51.25 63.8713 51.787 63.609C53.0873 62.9611 53.9165 61.6165 53.9165 60.1483V27.6498H81.4892L95.7677 43.9205L80.7917 57.2547C79.6001 58.3127 79.1808 60.005 79.7417 61.507C80.3021 63.0086 81.7201 64 83.3031 64H125.918H128V56.2915H93.3984L126.704 26.6488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNazLogoWhite);
export default __webpack_public_path__ + "static/media/naz-logo-white.d0f4a7ead2db7f280aeb11a854823ab6.svg";
export { ForwardRef as ReactComponent };